export default {
    SET_ITEMS(state, items) {
        state.items = items;
    },
    ADD_ITEM(state, item) {
        state.items.push(item);
    },
    UPDATE_ITEM(state, updated) {
        const idx = state.items.findIndex(i => i.id === updated.id);
        if (idx !== -1) state.items.splice(idx, 1, updated);
    },
    REMOVE_ITEM(state, id) {
        state.items = state.items.filter(i => i.id !== id);
    },
}
